<template>
    <a :href="urlWishList" class="wish-list-count" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <span class="badge-right-count" v-if="wishListCount">{{ wishListCount }}</span>
        <i class="fa" :class="{'fa-heart-o': !wishListCount, 'fa-heart text-primary': wishListCount}" aria-hidden="true"></i>
        <span class="d-none d-md-block">Merkzettel</span>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
